// extracted by mini-css-extract-plugin
module.exports = {"fileStyle":"_2W2SIOo_1-roRpSYcTTIEG"};